import { Container, Typography } from '@mui/material';

const UnderConstruction = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        We're working on this page... stay tuned.
      </Typography>
    </Container>
  );
};

export default UnderConstruction;
